const businessModelOptions = [
  {
    label: "B2B",
    value: 'b2b',
  },
  {
    label: "B2C",
    value: 'b2c',
  },
];

export default businessModelOptions